import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { BusyService, ConfigStorage, CurrentScreenStorage, ENVIRONMENT, RoutingHistoryService, ScreenInfo, TokenExpiryWarningDialogState, TokenStorage, globalCrudEntityPropertyCalculationWorker, startReactingToTokenExpiryWarnings } from '@scisys-uim/uim-common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  titleDefault: string;
  title: string;
  titleShort: string;
  pageTitle: string;

  private tokenExpiryDialogState: TokenExpiryWarningDialogState;

  constructor(public configService: ConfigStorage,
    public busyService: BusyService,
    private tokenStorage: TokenStorage,
    private routingHistory: RoutingHistoryService,
    private currentScreenStorage: CurrentScreenStorage,
    private titleService: Title,
    private dialog: MatDialog,
    @Inject(ENVIRONMENT) private environment: any) {
    this.routingHistory.enabled;
  }

  ngOnInit() {
    this.titleDefault = this.titleService.getTitle();
    this.title = this.titleDefault;
    this.titleShort = this.titleDefault;
    this.setPageTitle();

    this.configService.nextNonNullItem().subscribe(config => {
      this.title = config.title || this.title;
      this.titleShort = config.titleShort || this.titleShort || this.title;
      this.setPageTitle();
    });

    this.currentScreenStorage.nextNonNullItem().subscribe(screenInfo => {
      this.setPageTitle(screenInfo);
    });

    this.tokenExpiryDialogState = startReactingToTokenExpiryWarnings(this.tokenExpiryDialogState, this.dialog, this.tokenStorage);

    this.performCrudEntityTransientPropertyCalculationTasks();


    //EsalesUserRolesUtil.overrideEsalesRoleInfos(this.environment);
  }

  private setPageTitle(screenInfo?: ScreenInfo) {
    this.pageTitle = this.title;
    if (screenInfo && screenInfo.screenName) {
      this.pageTitle = this.titleShort + ' - ' + screenInfo.screenName;
    }
    this.titleService.setTitle(this.pageTitle);
  }

  async performCrudEntityTransientPropertyCalculationTasks() {
    while (true) {
      const waitMillis = 20;
      if (!globalCrudEntityPropertyCalculationWorker.addingTask) {
        globalCrudEntityPropertyCalculationWorker.performRemainingCalculationTasks();
      }
      await new Promise(resolve => setTimeout(resolve, waitMillis));
    }
  }
}
